var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgParkingBikeIncreased({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 320,
    height: 320,
    viewBox: "30 30 260 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "parkingBikeIncreased_svg__a",
    points: "0 .988 225.773 .988 225.773 156.967 0 156.967"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "parkingBikeIncreased_svg__c",
    points: ".242 .148 169.14 .148 169.14 95.59 .242 95.59"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M160.441 275.705c-64.147 0-116.152-52.004-116.152-116.15 0-64.146 52.005-116.15 116.152-116.15 64.147 0 116.152 52.004 116.152 116.15 0 64.146-52.005 116.15-116.152 116.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M153.035 242.145c15.642 0 28.375-12.733 28.375-28.375 0-15.648-12.733-28.381-28.375-28.381-3.98 0-7.76.831-11.204 2.316 6.626 12.901 13.406 24.422 13.52 24.61a3.278 3.278 0 01-1.158 4.493 3.296 3.296 0 01-1.663.46 3.275 3.275 0 01-2.826-1.613c-.46-.772-7.032-11.936-13.56-24.64-6.952 5.177-11.49 13.436-11.49 22.755 0 15.642 12.733 28.375 28.38 28.375"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44 43)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parkingBikeIncreased_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parkingBikeIncreased_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.636 136.625a36.55 36.55 0 013.91 1.499c.172.079.335.167.508.246 1.22.572 2.399 1.204 3.54 1.899.172.103.365.177.533.281l13.98-18.7v-8.739c-3.011-.528-8.2-2.106-12.45-6.924-1.101-1.257-1.427-2.426-.953-3.467.701-1.548 2.858-2.204 7.203-2.204 5.282 0 12.593.986 17.944 1.726 1.753.237 3.244.444 4.28.557 1.121.119 4.083.44 4.133 2.535.054 2.925-6.65 4.537-8.447 4.803-2.286.35-3.86 1.105-4.878 1.731l-.459.099c.074.276.168.547.168.848v6.83l48.172-.31c-1.338-4.577-2.419-9.133-3.07-11.89-.272-1.13-.455-1.933-.548-2.24-.548-1.336-1.99-1.37-2.33-1.42H65.54a3.268 3.268 0 010-6.534h7.192c2.202-.148 6.645.888 8.59 5.657.114.271.4 1.366.795 3.028.834 3.526 2.39 10.08 4.24 15.598 1.605 4.794 4.187 10.647 7.07 16.614a36.528 36.528 0 0114.943-3.2c15.037 0 27.98 9.074 33.668 22.019v-74.91a5.44 5.44 0 015.445-5.434h78.29c-.626-1.677-1.357-3.294-2.058-4.932h-90.538c-4.438 0-6.625-4.798-3.431-7.535L180.87 20.31C162.487 8.139 140.484.988 116.773.988h-.484C52.063.988-.003 52.996-.003 117.155v.483c0 10.228 1.574 18.982 1.574 18.982",
    mask: "url(#parkingBikeIncreased_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M54.452 193.355l-3.482 4.597a115.261 115.261 0 004.727 11.334l7.222-.753c-1.19-5.909-4.216-11.16-8.467-15.178"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.897 179.415)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "parkingBikeIncreased_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#parkingBikeIncreased_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M118.25 61.756V48.248C112.56 61.18 99.63 70.24 84.602 70.24c-20.272 0-36.76-16.457-36.76-36.68 0-12.583 6.384-23.702 16.083-30.315a579.383 579.383 0 01-1.48-3.097l-36.34 33.711a9.96 9.96 0 01.26 2.182c0 5.402-4.39 9.794-9.807 9.794-1.041 0-2.028-.206-2.965-.507l-10.87-1.856c-.601 2.31-1.474 4.5-2.48 6.613C21.48 77.74 54.901 95.591 92.515 95.591h.483c29.133 0 55.745-10.725 76.141-28.404h-45.449a5.438 5.438 0 01-5.441-5.431",
    mask: "url(#parkingBikeIncreased_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M79.846 205.418l-9.438-33.97-10.476 13.997c.01.01.014.024.029.03l-.025.028a37.121 37.121 0 014.091 4.327l.005-.005c.034.043.058.087.092.13a36.467 36.467 0 017.342 16.344l8.38-.88zM90.722 208.29l37.915-34.723a127.146 127.146 0 01-2.464-6.101l-50.31.322 10.868 38.66c1.487.309 2.827.964 3.99 1.843"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingBikeIncreased);
export default __webpack_public_path__ + "static/media/parkingBikeIncreased.9fadcffa.svg";
export { ForwardRef as ReactComponent };